"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ListItemText = _interopRequireDefault(require("@gogame/ui/ListItemText"));
var _MenuItem = _interopRequireDefault(require("@gogame/ui/MenuItem"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ToggleColorScale = function ToggleColorScale(_ref) {
  var onColorsScale = _ref.onColorsScale,
    colDef = _ref.colDef,
    onClick = _ref.onClick;
  var handleApply = function handleApply(event) {
    onColorsScale(colDef);
    onClick(event);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
    onClick: handleApply,
    sx: {
      padding: '6px 12px'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText["default"], {
      children: "".concat(colDef.isColorScale ? 'Hide' : 'Show', " color scales")
    })
  });
};
var _default = exports["default"] = ToggleColorScale;